import { Grid } from "@mui/material";
import { InsertDriveFile } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import MDBox from "@vendor/components/MDBox";
import MenuCard from "@vendor/examples/Cards/MenuCards";
import { usePermission } from "@shared/hooks/usePermission";
import { userContainPermission } from "@shared/utils/permission";

import type { ReactElement } from "react";

export const InvoiceListItem = (): ReactElement => {
    const { t } = useTranslation();
    const { permissionList } = usePermission("Tipo Factura");

    const existPermission = (permission: string): boolean => {
        return userContainPermission(permission, permissionList);
    };

    return (
        <Grid container spacing={3}>
            {existPermission("Factura Digital") && (
                <Grid
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 4,
                        xl: 4
                    }}>
                    <MDBox mb={1.5}>
                        <Link to="/gestion-de-facturas/prefactura">
                            <MenuCard
                                icon={InsertDriveFile}
                                title={t("preInvoice")}
                            />
                        </Link>
                    </MDBox>
                </Grid>
            )}
            <Grid
                size={{
                    xs: 12,
                    md: 6,
                    lg: 4,
                    xl: 4
                }}>
                <MDBox mb={1.5}>
                    <Link to="/gestion-de-facturas/facturas">
                        <MenuCard
                            icon={InsertDriveFile}
                            title={t("invoices")}
                        />
                    </Link>
                </MDBox>
            </Grid>
        </Grid>
    );
}
